import moment from "moment";

export default {
  async getProjects() {
    const resp = await fetch("/backend/projects.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: localStorage.getItem("isLogged"),
      },
      body: JSON.stringify({
        action: "getProjectsWithWarehouseData",
      }),
    });
    return await resp.json();
  },
  getDiffDays(date1, date2) {
    // eslint-disable-next-line use-isnan
    return isNaN(moment(date2).diff(moment(date1), "days"))
      ? ""
      : moment(date2).diff(moment(date1), "days");
  },
};
